<template>
    <Transition>
        <div v-if="visible" class="pre-loader">
            <LottieLoader :size="210" />
            <Transition name="loader-text" mode="out-in">
                <p :key="currentMessage" class="pre-loader__message">{{ currentMessage }}</p>
            </Transition>
        </div>
    </Transition>
</template>

<script lang="ts">
import globalModule from '@/store/modules/global.module';
import { Vue, Component } from 'vue-property-decorator'
import LottieLoader from './LottieLoader.vue'

const loadingMessages = [
    'Cargando tus unidades...',
    'Cargando ubicaciones...',
    'Cargando alertas...',
    'Cargando geocercas...',
    'Preparando el mapa...',
]

@Component({ components: { LottieLoader } })
export default class PreLoader extends Vue {
    messageIndex = 0
    messageInterval: ReturnType<typeof setInterval> | null = null

    get visible() {
        return globalModule.isLoading
    }

    get currentMessage() {
        return loadingMessages[this.messageIndex]
    }

    mounted() {
        if (this.visible) this.startInterval()
    }

    beforeDestroy() {
        this.stopInterval()
    }

    startInterval() {
        if (this.messageInterval) return
        this.messageInterval = setInterval(() => {
            this.messageIndex = (this.messageIndex + 1) % loadingMessages.length
        }, 1800)
    }

    stopInterval() {
        if (this.messageInterval) {
            clearInterval(this.messageInterval)
            this.messageInterval = null
        }
        this.messageIndex = 0
    }
}
</script>

<style lang="sass">
.pre-loader
    position: fixed
    inset: 0
    z-index: 2000
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center
    background: rgba(255, 255, 255, 0.8)
    backdrop-filter: blur(1.5px)
    -webkit-backdrop-filter: blur(1.5px)
</style>

<style lang="css" scoped>
.pre-loader__message {
    margin: 16px 0 0;
    color: #2563eb;
    font-size: 1.25rem;
    font-weight: 600;
    letter-spacing: -0.025em;
}

@media (min-width: 768px) {
    .pre-loader__message {
        font-size: 1.5rem;
    }
}

.v-enter-active,
.v-leave-active {
    transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}

.loader-text-enter-active,
.loader-text-leave-active {
    transition: opacity 0.35s ease, transform 0.35s ease;
}

.loader-text-enter-from,
.loader-text-leave-to {
    opacity: 0;
    transform: translateY(6px);
}
</style>
